module.exports = __webpack_public_path__ + "static/media/collageAlthar.9a8bf3f4.jpg";